import { render, staticRenderFns } from "./userManagement.vue?vue&type=template&id=4c88c97b&scoped=true&lang=pug"
import script from "./userManagement.vue?vue&type=script&lang=js"
export * from "./userManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c88c97b",
  null
  
)

/* custom blocks */
import block0 from "./userManagement.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports